module.exports = __webpack_public_path__ + "assets/media/iPhone-13.d3b20588.jpg";